import { useContext } from 'react';

import CloseImage from '@assets/svg/close-btn.svg';

import { CustomStatusContext } from '../../CustomStatus.query';

import {
  Close,
  Header,
  Text,
  Divider,
  Title,
} from './DeleteEquipmentStatus.styles';

export const DeleteEquipmentStatusError = () => {
  const { openDelete } = useContext(CustomStatusContext);

  return (
    <div>
      <Header>
        <Title>Error</Title>
        <Close onClick={() => openDelete.set(false)}>
          <img src={CloseImage} alt="close" />
        </Close>
      </Header>
      <Text>Error on load custom status</Text>
      <Divider />
    </div>
  );
};
